<template>
  <main class="ps-page ps-page--single-post" v-if="post">
    <div class="ps-post--detail ps-post--detail-with-hero">
      <div class="ps-post__thumbnail"
        :style="{ backgroundImage: 'url('+(post.image || defaultBanner)+')', backgroundSize: 'cover', backgroundPosition: 'center' }"
      >
      </div>
      <div class="ps-post__wrapper">
        <div class="ps-post__header">
          <div class="ps-post__meta">
            <span>{{ moment.utc(post.publishing_date).format('LL') }}</span>
          </div>
          <h1>{{ getTextByLang(post, 'title') }}</h1>
        </div>
        <div class="ps-post__content">
          <div class="text-center p-3">
            <a href="/login" type="button" class="btn btn-lg btn-primary px-4 py-2 text-white">
              {{ $t('create_indiefy_account') }}
            </a>
          </div>

          <div class="text-center mt-2 mb-2">
            <ins class="adsbygoogle"
              style="display:block; text-align:center;"
              data-ad-layout="in-article"
              data-ad-format="fluid"
              data-ad-client="ca-pub-8326584585992829"
              data-ad-slot="6959730131"></ins>
          </div>
          <div class="ps-document">
            <div v-html="getTextByLang(post, 'content')"></div>
          </div>
        </div>

        <div class="mt-3 px-3">
          <h4>More Articles</h4>
        </div>

        <div class="row mt-2">
          <div class="col-md-4" v-for="(post, index) in allPosts" v-bind:key="`other_${index}`">
            <div class="p-2">
              <div class="card">
                <div class="card-body">
                  <a :href="`https://indiefy.net/blog/${post.key}?lang=${lang}`">
                    <span v-if="lang === 'es'">{{ post.title_es }}</span>
                    <span v-if="lang !== 'es'">{{ post.title }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import Blog from '../../services/blog'
import moment from 'moment'

export default {
  name: 'BlogPost',
  data: function () {
    return {
      user: {},
      defaultImage: '/static/img/img-placeholder.jpg',
      defaultBanner: '/static/img/blog/default-banner.jpg',
      post: {},
      allPosts: [],
      moment: moment,
      lang: 'en'
    }
  },
  methods: {
    getAuthor: function (item) {
      let name = ''
      if (!item.author) {
        return 'Indiefy'
      }
      if (item.author.name) {
        name = item.author.name
        if (item.author.last_name) {
          name += ' ' + item.author.last_name
        }
      } else {
        name = item.author.username
      }
      return name
    },
    getTextByLang: function (item, option) {
      let textByLang = ''
      switch (option) {
        case 'title':
          if (this.lang === 'es') {
            textByLang = item.title_es || item.title
          } else {
            textByLang = item.title
          }
          break
        case 'content':
          if (this.lang === 'es') {
            textByLang = item.content_es || item.content
          } else {
            textByLang = item.content
          }
          break
        case 'description':
          if (this.lang === 'es') {
            textByLang = item.description_es || item.description || item.content
          } else {
            textByLang = item.description || item.content
          }
          break
      }
      return textByLang
    }
  },
  created: function () {
    this.user = this.$user

    if (this.$i18n) {
      this.lang = this.$i18n.locale
    }

    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang
    }

    if (this.lang !== 'es' && this.lang !== 'en') {
      this.lang = 'en'
    }

    Blog.get(this.$route.params.key).then(response => {
      this.post = response.data

      if (this.lang === 'es' && this.post.title_es) {
        window.document.title = this.post.title_es + ' | Indiefy Blog'
        window.$('meta[property="og:title"]').attr('content', this.post.title_es + ' | Indiefy Blog')
      } else {
        window.document.title = this.post.title + ' | Indiefy Blog'
        window.$('meta[property="og:title"]').attr('content', this.post.title + ' | Indiefy Blog')
      }

      if (this.lang === 'es' && (this.post.description_es || this.post.content_es)) {
        window.$('meta[name="description"]').attr('content', this.post.description_es || window.$(this.post.content_es).text().substr(0, 250))
        window.$('meta[property="og:description"]').attr('content', this.post.description_es || window.$(this.post.content_es).text().substr(0, 250))
      } else {
        window.$('meta[name="description"]').attr('content', this.post.description || window.$(this.post.content).text().substr(0, 250))
        window.$('meta[property="og:description"]').attr('content', this.post.description || window.$(this.post.content).text().substr(0, 250))
      }

      if (this.post.content.image) {
        window.$('meta[property="og:image"]').attr('content', this.post.image)
        window.$('meta[property="og:image:url"]').attr('content', this.post.image)
        window.$('meta[itemprop="image"]').attr('content', this.post.image)
        window.$('meta[property="og:image:type"]').attr('content', 'image/jpg')
      }

      setTimeout(() => {
        window.prerenderReady = true
      }, 50)

      if (!this.user.subscription) {
        setTimeout(() => {
          (window.adsbygoogle = window.adsbygoogle || []).push({})
        }, 3000)
      }
    })

    Blog.getAll({
      limit: 20,
      page: 1
    }).then(response => {
      this.allPosts = response.data.items
    })
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/sass/blog/vars.scss";
@import "../../assets/sass/blog/iconfont.scss";
@import "../../assets/sass/blog/button.scss";
@import "../../assets/sass/blog/v-list-group.scss";
@import "../../assets/sass/blog/list.scss";
@import "../../assets/sass/blog/application.scss";
@import "../../assets/sass/blog/v-list.scss";
@import "../../assets/sass/blog/v-icon.scss";
@import "../../assets/sass/blog/pages.scss";
@import "../../assets/sass/blog/header.scss";
@import "../../assets/sass/blog/attraction.scss";
@import "../../assets/sass/blog/section.scss";
@import "../../assets/sass/blog/block.scss";
/* @import "../../assets/sass/blog/post.scss"; */
@import "../../assets/sass/blog/form.scss";
@import "../../assets/sass/blog/widget.scss";
@import "../../assets/sass/blog/footer.scss";
</style>



// WEBPACK FOOTER //
// src/components/blog-components/BlogPost.vue